(function () {

  const MILESTONES = [1000, 2000, 3000, 4000, 5000, 7000, 10000];
  const MIN_VIEW_TIME = 1000;
  const VISIBILITY_THRESHOLD = 0.5;
  const TICK_INTERVAL = 500;

  const activeSections = new Map();

  function pushEvent(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...data
    });
  }

  function getSectionIndex(section) {
    return [...document.querySelectorAll("[data-section-id]")]
      .indexOf(section) + 1;
  }

  function startTracking(section) {

    const id = section.dataset.sectionId;
    if (!id || activeSections.has(id)) return;

    const now = Date.now();

    const state = {
      totalTime: 0,
      lastUpdate: now,
      firedMilestones: new Set(),
      firedSummary: false,
      interval: null
    };

    state.interval = setInterval(() => {

      const currentTime = Date.now();
      const delta = currentTime - state.lastUpdate;

      state.totalTime += delta;
      state.lastUpdate = currentTime;

      // Check milestones
      for (let ms of MILESTONES) {
        if (
          state.totalTime >= ms &&
          !state.firedMilestones.has(ms)
        ) {

          state.firedMilestones.add(ms);

          pushEvent("section_time_tick", {
            section_id: id,
            section_index: getSectionIndex(section),
            section_name: section.dataset.sectionName || "",
            section_type: section.dataset.sectionType || "",
            page_type: "index",
            tick_second: ms / 1000
          });
        }
      }

    }, TICK_INTERVAL);

    activeSections.set(id, state);
  }

  function stopTracking(section) {

    const id = section.dataset.sectionId;
    if (!id || !activeSections.has(id)) return;

    const state = activeSections.get(id);
    clearInterval(state.interval);

    if (!state.firedSummary && state.totalTime >= MIN_VIEW_TIME) {

      pushEvent("section_view_time", {
        section_id: id,
        section_index: getSectionIndex(section),
        section_name: section.dataset.sectionName || "",
        section_type: section.dataset.sectionType || "",
        page_type: "index",
        time_spent_ms: state.totalTime
      });

      state.firedSummary = true;
    }

    activeSections.delete(id);
  }

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      const section = entry.target;

      if (entry.isIntersecting) {
        startTracking(section);
      } else {
        stopTracking(section);
      }

    });

  }, {
    threshold: VISIBILITY_THRESHOLD
  });

  document.querySelectorAll("[data-section-id]").forEach(section => {
    observer.observe(section);
  });

})(); 